export default __webpack_public_path__ + "static/media/MeineLieferungen.37d79237.jpg";